import { OrderDetailsProps } from './OrderDetails';

export const OrderDetailsB = ({ order }: OrderDetailsProps) => {
  return <>OrderDetailsB</>;
};
